import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import Input from '../common/Input';
import Spinner from '../common/Spinner';

const RegisterForm = () => {
  const [form, setForm] = useState({
    fullname: '', email: '', phone: '', password: '', role: 'passenger'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm({...form, [e.target.name]: e.target.value});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await register(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="auth-form fade-in">
      <h1 className="auth-title">Create Account</h1>
      {error && <div className="error-message">{error}</div>}
      <Input label="Full Name" name="fullname" value={form.fullname} onChange={handleChange} required />
      <Input label="Email" type="email" name="email" value={form.email} onChange={handleChange} required />
      <Input label="Phone" name="phone" value={form.phone} onChange={handleChange} required />
      <Input label="Password" type="password" name="password" value={form.password} onChange={handleChange} required />
      <div className="input-group">
        <label>Role</label>
        <select name="role" value={form.role} onChange={handleChange}>
          <option value="passenger">Passenger</option>
          <option value="owner">Transport Owner</option>
          <option value="mashell">Mashell (Conductor)</option>
        </select>
      </div>
      <Button type="submit" className="full-width" disabled={loading}>
        {loading ? <Spinner /> : 'Register'}
      </Button>
      <style>{`
        .auth-form {
          width: 100%;
          max-width: 400px;
          margin: 0 auto;
        }
        .auth-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 2rem;
        }
        .error-message {
          background: #fee2e2;
          color: #991b1b;
          padding: 0.75rem;
          border-radius: var(--radius-sm);
          margin-bottom: 1rem;
        }
        .full-width { width: 100%; margin-top: 1rem; }
      `}</style>
    </form>
  );
};
export default RegisterForm;